var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"horizontal-nav-menu",class:_vm.rootThemeClasses},_vm._l((_vm.navMenuItems),function(item){return _c(_vm.resolveNavHeaderComponent(item),{key:item.header || item.title,tag:"component",attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }